import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
const IssuesActionsPreview = (props) => {
  const { apphome } = props;
  const page =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === apphome.pageView);
  return (
    <div style={{ display: 'flex', gap: '8px', overflow: 'hidden' }}>
      {page &&
        page.actions &&
        page.actions
          .slice(0, 5)
          .map((action) => (
            <Button className='apphome-display-btn'>
              {action.name.length > 15
                ? `${action.name.slice(0, 15)}...`
                : action.name}
            </Button>
          ))}
      {page.actions.length > 5 && (
        <Button className='apphome-display-btn'>
          + {page.actions.length - 5} more
        </Button>
      )}
    </div>
  );
};

export default IssuesActionsPreview;
